import { HiOutlineBuildingOffice } from 'react-icons/hi2'
import { useSelector } from 'react-redux'

import { ReturnReceiptReminderIconButton } from '../components/files/ReturnReceiptReminderWidget'
import HelpdeskNotificationsDropdown from '../components/helpdesk/HelpdeskNotificationsDropdown'
import LanguageSwitcher from '../components/other/LanguageSwitcher'
import UserMenu from '../components/other/UserMenu'
import Breadcrumbs from './Breadcrumbs'

const Navbar = () => {
  const company = useSelector((state) => state.company?.company)
  const user = useSelector((state) => state.user.user)

  return (
    <div className="flex w-full items-center justify-between border-b-2 border-b-[rgba(0,,0,1px,0)] py-2.5">
      <Breadcrumbs />
      <div className="flex items-center gap-1.5">
        <ReturnReceiptReminderIconButton />
        <LanguageSwitcher />
        {user?.token ? <HelpdeskNotificationsDropdown /> : null}
        <span className="mx-3 h-7 w-px bg-gray-200" aria-hidden />
        {company?.name ? (
          <div className="flex min-w-0 max-w-[260px] items-center gap-2 rounded-full border border-gray-100 bg-gray-50 px-4 py-2">
            <HiOutlineBuildingOffice className="shrink-0 text-gray-500" size={20} aria-hidden />
            <span className="truncate text-xs font-medium text-gray-700">{company.name}</span>
          </div>
        ) : null}
        <UserMenu />
      </div>
    </div>
  )
}

export default Navbar
